import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class WebhookRepository extends Base2Repository {
  getEntityIdentifier() {
    return "webhooks";
  }

  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({
      fetch: "/v1/webhooks",
      create: "/v1/webhooks",
      update: "/v1/webhooks"
    });
  }
}

export default new WebhookRepository();



// WEBPACK FOOTER //
// ./src/core/repository/webhook.repository.js